const shipperActions = {
  ACCEPT: "b88ec174-4fb5-48b2-a9d1-810c6a0b0880",
  COUNTER: "1cdd17ee-4183-44cc-b84b-fc458579e921",
  REJECT: "bec91455-e78a-4fee-af07-ff0b266e1132",
  SUBMIT: "2892d54e-21ea-4304-b88d-b92e8467c5fe",
  DELETED: "00622089-f38b-4c52-be24-6e8c2730e25a",
} as const;

export default shipperActions;
